import { getFetch } from '../fetch';
import { apiConfig } from '../config';
import { ParentProfile } from '../../../typings';

export function getParentProfile(): Promise<ParentProfile> {
    const { apiGetParentProfile } = apiConfig.getStaticUrls();

    return getFetch(apiGetParentProfile);
}
